import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import generatePDF, { Resolution } from "react-to-pdf";
import {
    ProjectDetailDto,
    ProjectRelatedEntitiesContainerDto,
    ProjectService,
} from "../../../../api/psc";
import PrintProjectsView from "./PrintProjectsView";

// updated
export default function PrintProjectsContainer() {
    const query = new URLSearchParams(window.location.search);
    const [baseInfo, setBaseInfo] =
        useState<ProjectRelatedEntitiesContainerDto>();
    const [projectDetails, setProjectDetails] = useState<ProjectDetailDto[]>(
        []
    );
    const [projectsReady, setProjectsReady] = useState<boolean>(false);
    const [dataNotFound, setDataNotFound] = useState<boolean>(false);
    const [isMobileDevice, setIsMobileDevice] = useState<boolean>(false);
    const [showPrintOptions, setShowPrintOptions] = useState<boolean>(false);
    const printContentRef = useRef<HTMLDivElement>(null);

    const printDataIdentifier = query.get("id");

    useEffect(() => {
        const printData = localStorage.getItem(printDataIdentifier);
        const ua = navigator.userAgent.toLowerCase();
        const isMobile = /android|iphone|ipad|ipod/i.test(ua);
        setIsMobileDevice(isMobile);

        const regex = /^[A-Z]{10}$/;
        const keys = Object.keys(localStorage);
        for (const key of keys) {
            if (regex.test(key)) {
                localStorage.removeItem(key);
            }
        }

        if (!printData) {
            setDataNotFound(true);
            return;
        }

        ProjectService.getProjectRelatedEntities("1").then((r) => {
            setBaseInfo(r);
            setProjectDetails(JSON.parse(printData));
            setProjectsReady(true);
            // localStorage.removeItem(printDataIdentifier);

            setTimeout(function () {
                const ua = navigator.userAgent.toLowerCase();
                const isAndroid = ua.indexOf("android") > -1;
                const isIos = /iphone|ipad|ipod/i.test(ua);

                window.onafterprint = function () {
                    setTimeout(function () {
                        if (!isAndroid && !isIos) {
                            window.close();
                        }
                    }, 2000);
                };

                if (isMobile) {
                    setShowPrintOptions(true);
                    return;
                }

                window.print();
            }, 1000);
        });
    }, []);

    const handlePrint = () => {
        setShowPrintOptions(false);
        window.print();
    };

    const handleDownloadPdf = async () => {
        const target = printContentRef.current;
        if (!target) {
            return;
        }

        const previousStyle = {
            width: target.style.width,
            minWidth: target.style.minWidth,
            maxWidth: target.style.maxWidth,
            marginLeft: target.style.marginLeft,
            marginRight: target.style.marginRight,
            backgroundColor: target.style.backgroundColor,
        };

        try {
            // Force A4 layout width so mobile viewport size does not squash content.
            target.style.width = "210mm";
            target.style.minWidth = "210mm";
            target.style.maxWidth = "210mm";
            target.style.marginLeft = "auto";
            target.style.marginRight = "auto";
            target.style.backgroundColor = "#fff";

            await generatePDF(() => printContentRef.current, {
                filename: `projects-${new Date().getTime()}.pdf`,
                method: "save",
                resolution: Resolution.MEDIUM,
                overrides: {
                    canvas: {
                        windowWidth: target.scrollWidth,
                    },
                },
            });
            setShowPrintOptions(false);
        } finally {
            target.style.width = previousStyle.width;
            target.style.minWidth = previousStyle.minWidth;
            target.style.maxWidth = previousStyle.maxWidth;
            target.style.marginLeft = previousStyle.marginLeft;
            target.style.marginRight = previousStyle.marginRight;
            target.style.backgroundColor = previousStyle.backgroundColor;
        }
    };

    if (dataNotFound) {
        return (
            <Stack sx={{ m: 8 }} alignItems="center">
                <Typography>
                    داده یافت نشده لطفا مجددا از بخش پروژه ها اقدام به پرینت
                    نمایید!
                </Typography>
            </Stack>
        );
    }

    return (
        <>
            <PrintProjectsView
                baseInfo={baseInfo}
                projectDetails={projectDetails}
                projectsReady={projectsReady}
                printContentRef={printContentRef}
            />

            <Dialog
                open={showPrintOptions && projectsReady && isMobileDevice}
                onClose={() => setShowPrintOptions(false)}
            >
                <DialogTitle>انتخاب خروجی</DialogTitle>
                <DialogContent>
                    <Box>
                        در موبایل می‌توانید مستقیم PDF بگیرید یا صفحه چاپ را
                        باز کنید.
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => setShowPrintOptions(false)}>
                        بستن
                    </Button>
                    <Button onClick={handlePrint}>چاپ</Button>
                    <Button variant="contained" onClick={handleDownloadPdf}>
                        دانلود PDF
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
